import { CampaignState } from 'constants/campaignStates';
import { MediaLayoutNone, MediaLayoutRight, MediaLayoutTop } from 'ui/icons';
import { baseColors } from 'ui/theme';
import { MediaLayout, Placement } from './types';

export const PLACEMENT_DISPLAY_CONTENT = {
  createPlacementsPrompt: {
    createPlacementButtonLabel: 'Create placement',
    createPlacementInstructionsLabel:
      'Before you can create an embedded message template, you’ll need to create a placement it can target.',
    learnMoreButtonLabel: 'Learn more in our docs',
    noPlacementsInAccountDocumentationPath:
      'https://support.iterable.com/hc/articles/23061496928788',
  },
  emptyState: {
    appsWebsitesLinkText: 'go to apps and websites',
    appsWebsitesPath: '/integrations/mobileApps',
    documentationLinkText: 'read our docs',
    documentationLinkTextPrefix: 'To learn more, ',
    headerText: 'Your placements will show up here',
    noDestinationsBodyText:
      'Apps and websites must be added before you can create placements. To get started, ',
    noPlacementsBodyText:
      'Placements correspond to message containers in your mobile apps and websites. To give them content, send embedded campaigns.',
  },
  missingPermission: {
    headerText: 'You do not have the required permissions to view this page',
    bodyText: 'Please contact your admin to update your permissions.',
  },
  formFieldPlaceholder: 'Select placement...',
  formFieldTitleLabel: 'Placement',
  managePlacementsDocsLabel: 'Documentation',
  managePlacementsLabel: 'Manage placements',
  managePlacementsPath: '/settings/placements',
  modalHeader: 'Embedded placement',
  noPlacementSelectedError: 'Placement required for template',
  placementsDocumentationPath: 'https://support.iterable.com/hc/articles/23060983437076',
  saveButtonLabel: 'Save placement',
};

export const MEDIA_LAYOUT_ICONS = {
  [MediaLayout.TOP]: <MediaLayoutTop height={24} width={20} color={baseColors.grey35} />,
  [MediaLayout.RIGHT]: <MediaLayoutRight height={16} width={32} color={baseColors.grey35} />,
  [MediaLayout.NONE]: <MediaLayoutNone height={16} width={32} color={baseColors.grey35} />,
};

export const ACTIVE_CAMPAIGN_STATES_SET = new Set([CampaignState.Running, CampaignState.Scheduled]);

export const DEFAULT_PLACEMENT: Placement = {
  placementName: 'All Fields',
  id: 0,
  isArchived: false,
  mediaLayout: MediaLayout.TOP,
  campaignLimit: 1,
  hasTitle: true,
  hasBody: true,
  hasMedia: true,
  hasDataFeeds: true,
  textFields: [],
  hasOpenAction: true,
  actionButtons: [],
  payload: '',
  destinations: [],
};

export const TOAST_ACTIONS = {
  archivePlacement: 'archivePlacement',
  createPlacement: 'createPlacment',
  updateDisplayPriorities: 'updateDisplayPriorities',
};
